import { useState } from 'react';

export type AllVersionsLineKey =
  | 'app_session'
  | 'users'
  | 'game_session'
  | 'test_session'
  | 'chat_session'
  | 'advertisements';

export function useDashboardChartVisibility() {
  const [hiddenAppVersions, setHiddenAppVersions] = useState<Set<string>>(new Set());
  const [hiddenUserVersions, setHiddenUserVersions] = useState<Set<string>>(new Set());
  const [hiddenGameVersions, setHiddenGameVersions] = useState<Set<string>>(new Set());
  const [hiddenTestVersions, setHiddenTestVersions] = useState<Set<string>>(new Set());
  const [hiddenChatVersions, setHiddenChatVersions] = useState<Set<string>>(new Set());
  const [hiddenAdvertisementVersions, setHiddenAdvertisementVersions] = useState<Set<string>>(new Set());
  const [hiddenAllVersionsLine, setHiddenAllVersionsLine] = useState<Set<AllVersionsLineKey>>(new Set());

  return {
    hiddenAppVersions,
    setHiddenAppVersions,
    hiddenUserVersions,
    setHiddenUserVersions,
    hiddenGameVersions,
    setHiddenGameVersions,
    hiddenTestVersions,
    setHiddenTestVersions,
    hiddenChatVersions,
    setHiddenChatVersions,
    hiddenAdvertisementVersions,
    setHiddenAdvertisementVersions,
    hiddenAllVersionsLine,
    setHiddenAllVersionsLine,
  };
}

export type DashboardChartVisibility = ReturnType<typeof useDashboardChartVisibility>;
